"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const WizardStep_1 = __importDefault(require("./components/WizardStep"));
const index_1 = require("../../index");
const WizardMapping = (props) => {
    const [maxStepIndex, setMaxStepIndex] = react_1.useState(0);
    const [activeStepIndex, setActiveStepIndex] = react_1.useState(0);
    const { isSubmitting } = index_1.useFormRendererContext();
    const handleNextButtonClick = () => {
        const target = activeStepIndex + 1;
        setActiveStepIndex(target);
        if (target > maxStepIndex) {
            setMaxStepIndex(target);
        }
    };
    const handlePreviousButtonClick = () => {
        const target = activeStepIndex - 1;
        if (target >= 0) {
            setActiveStepIndex(target);
        }
    };
    const stepsInfo = react_1.useMemo(() => {
        return props.fields.map((field) => ({
            title: field.title,
            isOptional: field.isOptional,
        }));
    }, [props.fields]);
    const field = react_1.useMemo(() => {
        return props.fields[activeStepIndex];
    }, [props.fields, activeStepIndex]);
    return (react_1.default.createElement(WizardStep_1.default, { "data-testid": props['data-testid'], activeStepIndex: activeStepIndex, maxStepIndex: maxStepIndex, stepsInfo: stepsInfo, fields: field.fields, title: field.title, description: field.description, submitButtonText: props.submitButtonText, onNextButtonClick: handleNextButtonClick, onPreviousButtonClick: handlePreviousButtonClick, isSubmitting: isSubmitting }));
};
exports.default = WizardMapping;
//# sourceMappingURL=index.js.map